/**
 * Это фикс для проблемы с кэшированием svg при использовании use в хроме.
 * В хроме на десктопе часть иконок иногда просто не отображаются. Вроде как проблема в том, что хром дважды прочитывает этот файл
 * из кэша - один раз из кэша в памяти, второй с диска. В результате разные элементы рендерят разные файлы (хотя технически это один файл),
 * при том, что один из этих файлов в памяти заменён и более не доступен. Как следствие, часть иконок не отображается.
 *
 * Для воспроизведения ошибки можно открыть какой-нибудь аромат в инкогнито в хроме на декстопе с включённым кэшем и несколько раз
 * перезагрузить страницу.
 *
 * Суть фикса заключается просто в том, что мы проходим по иконкам, и если иконка видима, но высота <use/> элемента равна нулю,
 * то мы его пересоздаём (через перезапись outerHTML).
 */
export default function initSvgSpriteFix() {
    const elements = document.querySelectorAll('svg.svg > use, svg.svg-clr > use');
    for (const element of elements) {
        // skip invisible elements
        if (!element.parentElement.getBoundingClientRect().height) {
            continue;
        }
        // skip rendered <use/> elements
        if (element.getBoundingClientRect().height) {
            continue;
        }
        // noinspection SillyAssignmentJS
        element.outerHTML = element.outerHTML;
    }
}
